import { useEffect, useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { MaskedLine } from "@/components/Reveal";

export default function PracticeHero() {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const textY = useTransform(scrollYProgress, [0, 1], [0, 70]);

  return (
    <section ref={ref} className="relative pt-28 md:pt-40 pb-14 md:pb-20" data-testid="practice-hero">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-8 items-center">
        <motion.div style={reduced ? {} : { y: textY }} className="md:col-span-12 max-w-4xl">
          <h1 className="font-serif font-medium tracking-tighter leading-[1.0] text-5xl" data-testid="advisory-headline">
            <MaskedLine delay={0.2}>The technology is only</MaskedLine>
            <MaskedLine delay={0.38}>
              <span className="italic text-ember">one part</span> of the system.
            </MaskedLine>
          </h1>
          <div className="mt-10 max-w-xl border-l-2 border-ember/60 pl-6">
            <MaskedLine delay={0.65}>
              <p className="text-base md:text-lg text-fog leading-relaxed">
                Knowledge creates value when it moves. At Mentheris, research and practice
                continuously inform one another. We investigate emerging questions, translate what
                we learn into knowledge others can use, and apply those insights through
                collaboration and experimentation, creating new observations, questions, and
                directions for research.
              </p>
            </MaskedLine>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
